"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');


var _blobject = require('shared/selectors/blobject');
var _peers = require('shared/selectors/peers');
var _common = require('shared/selectors/user/common');
var _relations = require('shared/selectors/user/relations');






var _timeZones = require('shared/services/timeZones');

/* The zone scheduled times are picked and shown in: the one the user last
 * chose on this device, else the device's. */
 const selectScheduleTimeZone = (state) =>
  _optionalChain([state, 'access', _ => _.scheduledMessages, 'optionalAccess', _2 => _2.timeZone]) || _timeZones.deviceTimeZone.call(void 0, ); exports.selectScheduleTimeZone = selectScheduleTimeZone

const NONE = Object.freeze([])
const NONE_HIDDEN = Object.freeze({})
const NO_VIEWER = Object.freeze({ userKey: null, teams: null, adminOrgs: null })

/* Who is looking, for which scheduled messages they see and what they may do
 * with them (scheduledRoleFor). The same object until the user changes. */
 const selectScheduledViewer = _toolkit.createSelector.call(void 0, 
  _common.selectCurrentUserV2,
  (user) => user
    ? {
        userKey: user.UserKey,
        teams: user.Teams,
        // The orgs the user is an approved admin of, as the server counts
        // them (isOrgAdmin in #889): an admin relationship not still pending.
        adminOrgs: new Set(Object.keys(user.Relationships || {}).filter(orgKey =>
          _relations.isUserAdminInOrg.call(void 0, user, orgKey ) && !_optionalChain([user, 'access', _3 => _3.Relationships, 'access', _4 => _4[orgKey ], 'optionalAccess', _5 => _5.Pending]))),
      }
    : NO_VIEWER,
); exports.selectScheduledViewer = selectScheduledViewer

/* A chat's scheduled, sending and failed-not-dismissed messages, by send
 * time. The same array until the chat's rows change. */
 const selectScheduledMessages = (
  state,
  conversationKey,
) =>
  (conversationKey && _optionalChain([state, 'access', _6 => _6.scheduledMessages, 'optionalAccess', _7 => _7.byConversation, 'access', _8 => _8[conversationKey]])) || NONE; exports.selectScheduledMessages = selectScheduledMessages

/* A chat's rows once its list has come back; undefined before (for example
 * a chat never opened in this session, or whose list is loading or failed). A
 * push for such a chat holds only its own row, so it doesn't count as the
 * list. */
 const selectLoadedScheduledMessages = (
  state,
  conversationKey,
) => {
  if (!conversationKey || !_optionalChain([state, 'access', _9 => _9.scheduledMessages, 'optionalAccess', _10 => _10.listed, 'access', _11 => _11[conversationKey]])) return undefined
  return state.scheduledMessages.byConversation[conversationKey] || NONE
}; exports.selectLoadedScheduledMessages = selectLoadedScheduledMessages

/* Whether the inbox row shows "Not sent": the chat has a failed scheduled
 * message of the viewer's own that they haven't dismissed (a teammate's
 * failure is its author's to deal with). Once the chat's list has loaded it
 * decides, since pushes, Dismiss and Retry keep it current; before that, the
 * chat's own count from the server. */
 const selectHasUnsentScheduled = (state, blobjectKey) => {
  const blobject = _blobject.selectBlobjectByKey.call(void 0, state, blobjectKey)
  if (!blobject) return false
  const rows = exports.selectLoadedScheduledMessages.call(void 0, state, blobject.WrappedKey)
  const me = exports.selectScheduledViewer.call(void 0, state).userKey
  if (rows) return rows.some(row => row.Status === 'failed' && !row.DismissedAt && row.AuthorKey === me)
  // The server counts the viewer's own only.
  return (_nullishCoalesce(blobject.ScheduledFailures, () => ( 0))) > 0
}; exports.selectHasUnsentScheduled = selectHasUnsentScheduled

/* The rows whose cancel is waiting for Undo (or the server): the thread
 * leaves them out. */
 const selectHiddenScheduledMessages = (state) =>
  _optionalChain([state, 'access', _12 => _12.scheduledMessages, 'optionalAccess', _13 => _13.hidden]) || NONE_HIDDEN; exports.selectHiddenScheduledMessages = selectHiddenScheduledMessages

/* Who a cancelled message won't go to, for the Cancel dialog: the chat's one
 * patient by name, or else the chat's own name (several patients, or none).
 * Empty for a chat that isn't loaded. */
 const selectCancelRecipientName = (state, blobjectKey) => {
  const blobject = _blobject.selectBlobjectByKey.call(void 0, state, blobjectKey)
  if (!blobject) return ''
  // SAFETY: the subscriber map is keyed by patient key.
  const patientKeys = Object.keys(blobject.PatientSubscribers || {}) 
  const patientName = patientKeys.length === 1 ? _optionalChain([_peers.selectPatientByKey.call(void 0, state, patientKeys[0]), 'optionalAccess', _14 => _14.Name, 'optionalAccess', _15 => _15.trim, 'call', _16 => _16()]) : ''
  return patientName || _optionalChain([blobject, 'access', _17 => _17.Name, 'optionalAccess', _18 => _18.trim, 'call', _19 => _19()]) || ''
}; exports.selectCancelRecipientName = selectCancelRecipientName
